import { Link } from "react-router-dom";
import type { Article } from "@/mocks/types";
import { getCategoryById } from "@/mocks/categories";

export default function ArticleCard({ article }: { article: Article }) {
  const category = getCategoryById(article.categoryId);

  return (
    <article className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden transition-all duration-300 hover:border-primary-200/60 cursor-pointer">
      <Link to={`/article/${article.slug}`} className="block">
        <div className="relative w-full aspect-[16/10] overflow-hidden">
          <img
            src={article.imageUrl}
            alt={article.title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          {category && (
            <div className="absolute top-3 left-3">
              <span className="inline-block px-2.5 py-0.5 text-xs font-medium bg-primary-500 text-white rounded-full whitespace-nowrap">
                {category.name}
              </span>
            </div>
          )}
        </div>
      </Link>
      <div className="p-4 md:p-5">
        <Link to={`/article/${article.slug}`} className="block">
          <h3 className="text-base font-heading font-semibold text-foreground-900 leading-snug mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
            {article.title}
          </h3>
        </Link>
        <p className="text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-2">
          {article.excerpt}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-time-line"></i>
            {article.readTime} 分钟阅读
          </span>
          <span>{article.publishDate}</span>
        </div>
      </div>
    </article>
  );
}